<template>
    <section class="current_room_edit">
        <div class="comp_scroller">
            <div class="comp_content" :class="{'state-loading':!data}">
                <template v-if="data">
                    <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle"
                            v-if="subScreen !== 'guest' && subScreen !== 'account'">
                        <div class="col">
                            <h1 class="part_ui_heading"><span>{{ data.masterGuest.full_name }}</span></h1>
                        </div>
                    </header>
                    <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)" v-if="!subScreen">
                        <div class="info-row">
                            <div class="cell">
                                <div class="content" style="gap: 10px">
                                    <room-label :label="data.room.label"/>
                                    <div style="font-weight: 500">{{ data.room.type.label }}</div>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="content">
                                    <span>{{ data.guests.length }}x&nbsp;</span>
                                    <span class="icon icon--person-fill" style="font-size: 22px;margin-top: -6px"/>
                                    <span v-if="data.isGroup">({{ $t('group') }})</span>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="content">
                                    <span>{{ data.nightsCount }}x&nbsp;</span>
                                    <span class="icon icon--moon-fill" style="font-size: 14px;margin-top: -2px"/>
                                </div>
                            </div>
                        </div>
                        <div class="guests">
                            <div v-for="(guest, index) in data.guests">
                                <div class="guest"
                                     v-on:click="$router.push(`/guests/edit/${roomId}/guest/${index}`)">
                                    <div class="name">{{ guest.profile.full_name }}</div>
                                    <div class="master" v-if="index===0">({{ $t('master') }})</div>
                                    <div class="arrow"><span class="icon icon--chevron-right"/></div>
                                </div>
                            </div>
                        </div>

                        <div class="items">
                            <edit-item :label="$t('source')"
                                       labelFor="source-id">
                                <div class="part_ui_select">
                                    <custom-search-select
                                        id="source-id"
                                        v-model="data.sourceId"
                                        :options="selectSources"
                                        :id-func="o=>o.id"
                                        :label-func="o=>`${o.name} (${ o.code })`"/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('arrival')"
                                       labelFor="check-in-date">
                                <div class="part_ui_input">
                                    <date-input v-model="data.checkInDate"
                                                v-on:input="getSelectRoomNumbers()" required
                                                disabled/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('departure')"
                                       labelFor="check-out-date">
                                <div class="part_ui_input">
                                    <date-input v-model="data.checkOutDate"
                                                disabled
                                                v-on:input="getSelectRoomNumbers()" required/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('pricelist')"
                                       labelFor="price-list-id">
                                <div class="part_ui_select">
                                    <custom-search-select
                                        id="price-list-id"
                                        v-model="data.priceListId"
                                        :options="selectPriceLists"
                                        :id-func="o=>o.id"
                                        :label-func="o=>o.name"/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('price_type')"
                                       labelFor="price-type-id">
                                <div class="part_ui_select">
                                    <custom-search-select
                                        id="price-type-id"
                                        v-model="data.priceTypeId"
                                        :options="selectPriceTypes"
                                        :id-func="o=>o.id"
                                        :label-func="o=>o.code"/>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('price_mask')"
                                       class="clickable"
                                       v-on:click="$router.push(`/guests/edit/${$route.params.roomId}/priceMask`)">
                                <div class="part_ui_input">
                                    <input id="price-mask-text" :value="priceMaskText" type="text" readonly>
                                </div>
                            </edit-item>
                            <div style="padding: 12px 0">
                                <edit-item :label="$t('price_per_day')" class="naked">
                                    <div>{{ data.pricePerDay }} {{ this.currency }}</div>
                                </edit-item>
                                <edit-item :label="$t('price_total')" class="naked">
                                    <div>{{ data.totalPrice }} {{ this.currency }}</div>
                                </edit-item>
                            </div>
                            <edit-item class="clickable" :label="$t('account_num') +': ' + data.currentAccount.id"
                                       v-on:click="account?$router.push(`/guests/edit/${$route.params.roomId}/account`):{}">
                                <div class="part_ui_input part_ui_select">
                                    <!--FIXME nemám účet-->
                                    <input id="account-num"
                                           :value="`${data.currentAccount.totalAmount} ${this.currency}`" readonly>
                                </div>
                            </edit-item>
                            <edit-item :label="$t('note')" labelFor="note" style="margin-top: 27px">
                                <div class="part_ui_input part_ui_textarea">
                                    <textarea type="date" id="note" v-model="data.note" ref="note"
                                              style="text-align: right"
                                              v-autosize="data.note"/>
                                </div>
                            </edit-item>
                        </div>

                        <div class="elm_button">
                            <button class="part_ui_btn part_ui_btn_primary mod--block"
                                    v-on:click="save()">{{ $t('save_room') }}
                            </button>
                        </div>
                    </div>

                    <div v-else-if="subScreen === 'priceMask'">
                        <price-mask-edit
                            :price-mask-map="data.priceMask"
                            :from="data.checkInDate"
                            :to="data.checkOutDate"
                            :on-close="()=>$router.back()"/>
                    </div>

                    <guest-profile-detail v-else-if="subScreen==='guest'"
                                          :profile="data.guests[Number(subScreenItemId)].profile"
                                          :note="data.guests[Number(subScreenItemId)].note"/>

                    <room-account-detail v-else-if="subScreen==='account' && account"
                                         :roomLabel="data.room.label"
                                         :guestName="data.masterGuest.full_name"
                                         :defaultCurrency="this.currency"
                                         :account="account"/>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment/moment';
import {computePriceMaskText, priceMaskArrayToMap, sanitize} from '../../main';
import PriceMaskEdit from '../part/price-mask-edit.vue';

export default {
    components: {PriceMaskEdit},
    name: 'current-room-edit',
    data() {
        return {
            moment: moment,
            roomId: null,
            data: undefined,
            selectSources: [],
            selectRoomTypes: [],
            selectPriceTypes: [],
            selectPriceLists: [],
            selectPriceMasks: [],
            subScreen: undefined,
            subScreenItemId: undefined,
            priceMaskText: '',
            priceMask: [],
            currency: null,
            account: undefined
        }
    },
    mounted() {
        this.currency = localStorage.getItem('currency');
        this.roomId = this.$route.params.roomId;

        Promise.all([this.getSelectPriceTypes(), this.getSelectSources()])
            .then(async () => {
                await this.loadData()
            })
        this.parseRoute()
    },
    watch: {
        'data.priceListId': function () {
            this.getPriceTypes();
        },
        'data.priceMask': function () {
            this.computePriceMaskText()
        },
        $route: function () {
            this.parseRoute()
        }
    },
    methods: {
        parseRoute() {
            this.subScreen = this.$route.params.subScreen;
            this.subScreenItemId = this.$route.params.subScreenItemId;
        },
        async loadAccount() {
            let query = `{
                listAccountItems(current_account_id: ${this.data.currentAccount.id},paid:false){
                    id
                    price
                    default_currency_price
                    currency{
                        code
                    }
                    raster {
                        name
                    }
                }
            }`

            await axios({
                data: query
            }).then(async (response) => {
                let res = response.data.data.listAccountItems;

                this.account = {
                    id: this.data.currentAccount.id,
                    items: res,
                    totalAmount: this.data.currentAccount.totalAmount
                }
            }).catch(error => {
                this.showError(error)
            });
        },
        async loadData() {
            let query = `{
              getCurrentRoom(id: ${this.roomId}) {
                id
                master_guest {
                  id
                  profile {
                    full_name
                  }
                  guest_group {
                    is_group
                    reservation_source_id
                  }
                }
                current_guests {
                  profile {
                    full_name
                    first_name
                    last_name
                    email_address
                    phone_number
                    address_street
                    address_zip
                    address_town
                    address_hn
                    country_id
                    note
                    citizenship_id
                    ic_number
                    birth_date
                    birth_town
                    licence_plate
                  }
                }
                room {
                  id
                  code
                  room_type {
                    id
                    code
                  }
                }
                nights
                checkin_date
                checkout_date
                pricelist_id
                pricetype_id
                current_account {
                  id
                  total_amount
                },
                total_price
                note,
                price_plan {
                    date
                    price
                }
              }
            }`;

            await axios({
                data: query
            }).then(async (response) => {
                let res = response.data.data.getCurrentRoom;
                this.data = {
                    id: res.id,
                    masterGuest: res.master_guest.profile, // Celý objekt profilu
                    isGroup: res.master_guest.guest_group.is_group,
                    sourceId: res.master_guest.guest_group.reservation_source_id,
                    nightsCount: res.nights,
                    room: {
                        label: res.room.code,
                        type: {
                            id: res.room.room_type.id,
                            label: res.room.room_type.code,
                        }
                    },
                    guests: res.current_guests,
                    checkInDate: moment(res.checkin_date).toDate(),
                    checkOutDate: moment(res.checkout_date).toDate(),
                    priceListId: res.pricelist_id,
                    priceTypeId: res.pricetype_id,
                    currentAccount: {
                        id: res.current_account.id,
                        totalAmount: res.current_account.total_amount
                    },
                    totalPrice: res.total_price,
                    pricePerDay: (res.total_price / res.nights).toFixed(2),
                    note: res.note ? res.note : '',
                    priceMask: priceMaskArrayToMap(res.price_plan),
                }

                this.computePriceMaskText();
                await this.getSelectRoomNumbers();
                await this.loadAccount();
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectSources: async function () {
            await axios({
                data: `{
                        listReservationSources {
                          id
                          code
                          name
                        }
                      }`
            }).then(response => {
                this.selectSources = response.data.data.listReservationSources;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomTypes: function () {
            return axios({
                data: `{
                        listRoomTypes {
                          id
                          code
                          description
                        }
                      }`
            }).then(response => {
                this.selectRoomTypes = response.data.data.listRoomTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectPriceTypes: async function () {
            await axios({
                data: `{
                        listPriceLists(deleted: false) {
                          id
                          name
                          price_types {
                            id
                            code
                          }
                        }
                      }`
            }).then(response => {
                this.selectPriceLists = response.data.data.listPriceLists;

                let priceTypes = [];

                response.data.data.listPriceLists.forEach(function (item) {
                    item.price_types.forEach(function (itm) {
                        itm.pricelist_id = item.id;
                        priceTypes.push(itm);
                    });
                });

                this.selectPriceTypesAll = priceTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomNumbers: function () {
            // FIXME nutné ověřit u PB, zda je to OK
            const query = `{
                    listAvailableRooms(free_from: "${moment(this.data.checkInDate).format('YYYY-MM-DD')}",
                    free_to: "${moment(this.data.checkOutDate).format('YYYY-MM-DD')}",
                    room_type_id: ${this.data.room.type.id},
                    available_only: true ${this.id ? `,
                    filter_reservation_number: ${this.id}` : ''})
                    {
                        id
                        code
                    }
                }`

            return axios({
                data: query
            }).then(response => {
                this.selectRoomNumbers = response.data.data.listAvailableRooms;
            }).catch(error => {
                this.showError(error)
            });
        },
        getPriceTypes() {
            let selectPriceTypes = [];

            const priceListId = this.data.priceListId;

            if (priceListId) {
                this.selectPriceTypesAll.forEach(function (item) {
                    if (parseInt(item.pricelist_id) === parseInt(priceListId)) {
                        selectPriceTypes.push(item);
                    }
                });
            }

            this.selectPriceTypes = selectPriceTypes;
        },
        computePriceMaskText() {
            this.priceMaskText = computePriceMaskText(this.data.priceMask, this.currency)
        },
        async save() {
            const {data, $router} = this
            await axios({
                data: `mutation updateCurrentRoom {
                        createUpdateCurrentRooms (current_rooms:[
                                {
                                    id: ${data.id},
                                    note: "${data.note ? sanitize(data.note) : ''}",
                                    pricelist_id: ${data.priceListId},
                                    pricetype_id: ${data.priceTypeId},
                                    reservation_source_id: ${data.sourceId}
                                }
                            ]) {
                            ok
                        }
                      }`
            }).then(res => {
                if (res.data.data.createUpdateCurrentRooms.ok) {
                    this.$dialog.alert(this.$t('room_saved'), {okText: this.$t('ok')}).then(function (dialog) {
                        $router.back()
                    });
                } else {
                    this.$dialog.alert(this.$t('unknown_error'), {okText: this.$t('ok')});
                }
            }).catch(error => {
                this.showError(error)
            });
        },
    }
}
</script>

<style scoped lang="less">
@import "../../less/_core/global/font_sizes.less";
@import "../../less/_core/theme/core/colors.less";

header {
    margin-bottom: 2px;
}

.comp_content {
    min-height: 100%; // TODO kvůli loadingu. asi pryč?
    display: flex;
    flex-direction: column;
}

.info-row {
    display: flex;
    margin-bottom: 10px;
    gap: 15px;

    .cell {
        display: flex;
        flex: 1;
        justify-content: flex-start;

        .content {
            display: flex;
            align-items: center;
            flex: 1;
        }
    }
}

.guests {
    margin-bottom: 20px;

    .guest {
        display: flex;
        align-items: baseline;
        padding: 12px 0 8px 0;
        border-bottom: 1px solid @color-brown-light;
        cursor: pointer;

        .name {
            flex: 0;
            white-space: nowrap;
            font-size: @r18;
            color: @color-c;
        }

        .master {
            flex: 0;
            margin-left: 10px;
            font-size: @r11;
            color: @color;
            text-transform: uppercase;
            font-weight: 500;
        }

        .arrow {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            color: @color-c;

            .icon {
                font-weight: 600;
            }
        }
    }
}

input:disabled {
    color: @color-brown-light !important
}

.part_ui_textarea {
    align-self: stretch;

    textarea {
        display: block;
        font-size: @18;
        line-height: 1.5;
        color: @color-brown-light;
        padding: 0 4px;
    }
}

.elm_button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 55px;
}

.elm_button {
    display: flex;
    justify-content: center;

    button {
        max-width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/current-room-edit.vue